// extracted by mini-css-extract-plugin
export default {"dashboard":"ImpactSummaryDashboard_dashboard__rmGcJ"};